import styled from 'styled-components';

export const CardWrapper = styled('div')`
${({ theme }) => `
    width: 100%;
    max-width: ${theme.spacing.full};
    box-sizing: border-box;
    @media screen and (max-width: ${theme.breakpoint.sm}) {
        background:transparent;
        box-shadow:none;
        margin-left: auto;
        margin-right: auto;
    }
`}
`;

export const ButtonWrapper = styled('div')`
${({ theme }) => `
    display: flex;
    justify-content: center;
    align-self:center;
    margin-left:auto;
    margin-right:auto;
    margin-top:95px;
    & > button  {
        background: transparent;
        color:#304E5C;
        border: 1px solid #304E5C;
        font-weight:bold;
        height:56px;
        &:hover {
            background-color:#304E5C!important;
            color:#FFFFFF;
            opacity: 0.3;
        }
        @media screen and (min-width: ${theme.breakpoint.sm}) {
            width:260px;
        }
    }
    @media screen and (max-width: ${theme.breakpoint.sm}) {
        flex-direction: column;
        justify-content: center;
        flex-wrap: wrap;
        margin-top: 50px;
    }
`}
`;

export const CheckerWrapper = styled('div')`
${({ theme }) => `
    margin-top:88px;
    justify-content:center;
    @media screen and (max-width: ${theme.breakpoint.sm}) {
        margin-top: 50px;
    }
`}
`;

export const TitleWrapper = styled('div')`
${({ theme }) => `
    display: flex;
    align-items: center;
    justify-content: center;
    text-align:center;
    margin-top:70px;
    font-weight:bold;
    font-size:24px;
    @media screen and (max-width: ${theme.breakpoint.sm}) {
        margin-top:83px;
    }
`}
`;

export const TextWrapper = styled('div')`
${({ theme }) => `
    display: block;
    align-items: center;
    justify-content: center;
    max-width:532px;
    font-size:16px;
    text-align:center;
    margin-top:32px;
    color:#707070;
    @media screen and (min-width: ${theme.breakpoint.sm}) {
        margin-top:16px;
        margin-bottom:50px;
    }
`}
`;

export const Tooltip = styled.span`
color: #0087c8;
cursor: pointer;
position: relative;
`;

export const TooltipText = styled.span`
display: none;
position: absolute;
z-index: 1;
top: -50px;
right: -76px;
width: 250px;
background-color: white;
border: 0.5px solid #c3cfd7;
border-radius: 10px;
box-shadow: 0px 0px 6px #4c556433;
font-size: 12px;
color: #304e5c;
padding: 8px 16px 8px 16px;
${Tooltip}:hover & {
    display: block;
}

&::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    z-index: 1;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #ffffff transparent transparent transparent;
}
`;
